// ===================================================================
//  Diagram component-type to color mapping
//  Palette synced with the bot team's checker tool.
// ===================================================================

// Border colors by component type
const DIAGRAM_TYPE_COLORS: Record<string, string> = {
  relay: '#FF8C00',
  contactor: '#FF8C00',
  module: '#E040FB',
  terminal_block: '#00BCD4',
  cable: '#BB66FF',
  switch: '#4CAF50',
  sensor: '#4CAF50',
  circuit_breaker: '#009688',
  fuse: '#FFC107',
  motor: '#8BC34A',
  transformer: '#EC407A',
  plc_module: '#E040FB',
  valve: '#4CAF50',
};
const DEFAULT_COLOR = '#9E9E9E';

/** Return the display color for a diagram hotspot by its component type. */
export const getDiagramColor = (type?: string): string =>
  (type && DIAGRAM_TYPE_COLORS[type]) || DEFAULT_COLOR;

/** Semi-transparent background (12% opacity of border color). */
export const getDiagramBgColor = (type?: string): string => {
  const hex = getDiagramColor(type);
  return hex + '1F'; // ~12% opacity
};

/** Label pill colors (solid bg, white text by default). */
export const getDiagramLabelColors = (type?: string): { bg: string; fg: string } => ({
  bg: getDiagramColor(type),
  fg: '#FFFFFF',
});
